
import {Component, Vue} from 'vue-property-decorator';
import Pagination from "@/components/Pagination/index.vue";
import {pageFactoryLoadingPlan, pageHenganLoadingPlan, pagePurchaseOder} from "@/api/invoice/index";
import {Decimal} from "decimal.js";

@Component({
  name: 'InvoiceReceiptChooser.vue',
  components: {Pagination}
})
export default class InvoiceReceiptChooser extends Vue {

  public searchForm = [
    {
      label: "单据类型",
      prop: "receiptType",
      key: "receiptType",
      type: "select",
      value: "",
      options: [
        {
          name: "报关计划",
          value: "flp",
        },
        {
          name: "含包装配件采购订单",
          value: "po",
        },
        {
          name: "出库单",
          value: "hlp",
        },
      ],
      clearable: true,
      resetKey: {label: "name", value: "value"},
    },
    {
      label: "单据号",
      prop: "code",
      key: "code",
      type: "input",
      value: "",
      clearable: true,
    },
  ]
  private showDialog = false;
  private loading = false;
  private options = {
    title: "",
    id: "",
    factoryId: null,
    factoryName: null,
    company: null,
    selectedReceipt: []
  }
  //单据号码	客人简称	报关品名	单据金额	已登记金额	本次登记金额
  private tableCol = [
    {
      label: "单据号码",
      prop: "receiptCode",
      key: "receiptCode",
    },
    {
      label: "报关品名",
      prop: "label",
      key: "label",
    },
    {
      label: "可分配金额",
      prop: "unAllocateAmount",
      key: "unAllocateAmount",
    },
  ]
  private table = {
    list: [] as any[],
    pageNumber: 1,
    pageSize: 20,
    total: 0,
  };
  private queryForm = {receiptType: null, code: null, supplierId: null, company: null};

  private selectInvoice = [];

  public querySearch(data) {
    this.table.pageNumber = 1;
    this.queryForm = data && data !== "reset" ? data : {};
    this.queryForm.supplierId = this.options.factoryId;
    this.queryForm.company = this.options.company;
    this.getList();
  }

  private async getList() {
    this.loading = true;
    if (this.queryForm.receiptType == 'flp') {
      pageFactoryLoadingPlan(this.queryForm, {pageNumber: this.table.pageNumber, pageSize: this.table.pageSize})
          .then(res => {
            const data = res.content.filter(item => {
              return this.options.selectedReceipt.find(i => i.receiptId === item.id) === undefined
            }).map(item => {
              let label = '';
              if (!item.productName) {
                label = '未知品名'
              } else if (item.productName.length <= 3) {
                label = item.productName.slice(0, 3).join(',');
              } else {
                label = item.productName.slice(0, 3).join(',') + "等";
              }
              return {
                supplierId: this.options.factoryId,
                type: "FACTORY_LOADING_PLAN",
                label: label,
                id: item.id,
                receiptId: item.id,
                receiptCode: item.code,
                unAllocateAmount: item.unAllocateAmount,
                amount: item.amount,
                totalAllocateAmount: new Decimal(item.amount).sub(new Decimal(item.unAllocateAmount)).toNumber(),
                allocateAmount: item.unAllocateAmount,
                maxProp: item.unAllocateAmount,
                extMap: {
                  customerAbbr: item.customerAbbr,
                  productName: item.productName?.join(','),
                  hqPackingListCode: item.hqPackingListCodes?.join(','),
                  purchaseOrderCode: item.purchaseOrderCodes?.join(','),
                }
              }
            })
            this.table.list = data;
            this.table.total = Number(res.total);
            console.log(this.table)
          })
          .finally(() => this.loading = false)
    }
    if (this.queryForm.receiptType == 'po') {
      pagePurchaseOder(this.queryForm, {pageNumber: this.table.pageNumber, pageSize: this.table.pageSize})
          .then(({data}) => {
            this.table.list = data.list.filter(item => {
              return this.options.selectedReceipt.find(i => i.receiptId === item.id) === undefined
            }).map(item => {
              let label = '';
              if (!item.projectNames) {
                label = '未知品名'
              } else if (item.projectNames.length <= 3) {
                label = item.projectNames.slice(0, 3).join(',');
              } else {
                label = item.projectNames.slice(0, 3).join(',') + "等";
              }
              return {
                supplierId: this.options.factoryId,
                type: "PURCHASE_ORDER",
                label: label,
                id: item.id,
                receiptId: item.id,
                receiptCode: item.code,
                unAllocateAmount: item.unAllocateAmount,
                amount: item.paymentAmount,
                totalAllocateAmount: new Decimal(item.paymentAmount).sub(new Decimal(item.unAllocateAmount)).toNumber(),
                allocateAmount: item.unAllocateAmount,
                maxProp: item.unAllocateAmount,
                extMap: {
                  customerAbbr: item.customerAbbr,
                  productName: item.projectNames?.join(','),
                }
              }
            })
            this.table.total = Number(data.total);
          })
          .finally(() => this.loading = false)
    }
    if (this.queryForm.receiptType == 'hlp') {
      pageHenganLoadingPlan(this.queryForm, {pageNumber: this.table.pageNumber, pageSize: this.table.pageSize})
          .then(res => {
            const data = res.content.filter(item => {
              return this.options.selectedReceipt.find(i => i.receiptId === item.id) === undefined
            }).map(item => {
              let label = '';
              if (!item.productName) {
                label = '未知品名'
              } else if (item.productName.length <= 3) {
                label = item.productName.slice(0, 3).join(',');
              } else {
                label = item.productName.slice(0, 3).join(',') + "等";
              }
              return {
                supplierId: this.options.factoryId,
                type: "DELIVERY_LIST",
                label: label,
                id: item.id,
                receiptId: item.id,
                receiptCode: item.code,
                unAllocateAmount: item.unAllocateAmount,
                modifiedSupplier: item.modifiedSupplier,
                originalSupplier: item.originalSupplier,
                amount: item.amount,
                totalAllocateAmount: new Decimal(item.amount).sub(new Decimal(item.unAllocateAmount)).toNumber(),
                allocateAmount: item.unAllocateAmount,
                maxProp: item.unAllocateAmount,
                extMap: {
                  customerAbbr: item.customerAbbr,
                  productName: item.productName?.join(','),
                  hqPackingListCode: item.hqPackingListCodes?.join(','),
                  purchaseOrderCode: item.purchaseOrderCodes?.join(','),
                }
              }
            })
            this.table.list = data;
            this.table.total = Number(res.total);
          })
          .finally(() => this.loading = false)
    }
  }

  public handleSelectionChange(val) {
    this.selectInvoice = val;
  }

  private confirmLoading = false;

  public handleSubmit() {
    this.confirmLoading = true;
    if (this.selectInvoice.length === 0) {
      return;
    }
    this.$emit("confirm", this.selectInvoice)
    this.showDialog = false;
    this.confirmLoading = false;
  }


  public async openDialog(obj, options) {
    this.reset()
    this.options = {...options, ...obj};
    this.showDialog = true;
  }

  public reset() {
    this.table = {
      list: [] as any[],
      pageNumber: 1,
      pageSize: 20,
      total: 0,
    };
    this.searchForm[0].value = '';
    this.searchForm[1].value = '';
    this.selectInvoice = [];
    this.$nextTick(() => {
      (this.$refs.baseTableRef as any).clearSelection();
    })
  }
}
